
// Preset of Organization Parameters
const PRESET_ORGANIZATION_PARAMETERS = {
  SUPPORTED_CLOUD: 'SUPPORTED_CLOUD',
  CONNECTOR: 'CONNECTOR',
  DEFAULT_SNOWFLAKE_REGION_ID: 'DEFAULT_SNOWFLAKE_REGION_ID',
  RESOLUTION_MAX_TIMEOUT_HOURS: 'RESOLUTION_MAX_TIMEOUT_HOURS',
  IDENTITY_RESOLUTION_CLOUD: 'IDENTITY_RESOLUTION_CLOUD',
  IDENTITY_RESOLUTION_REGION: 'IDENTITY_RESOLUTION_REGION',
  IDENTITY_RESOLUTION_SUB_REGION: 'IDENTITY_RESOLUTION_SUB_REGION',
  IDENTITY_RESOLUTION_SNOWFLAKE_REGION_ID: 'IDENTITY_RESOLUTION_SNOWFLAKE_REGION_ID',
  SNOWFLAKE_RESOLUTION_CLOUD: 'SNOWFLAKE_RESOLUTION_CLOUD',
  SNOWFLAKE_RESOLUTION_REGION: 'SNOWFLAKE_RESOLUTION_REGION',
};

export const PRESET_ORGANIZATION_PARAMETERS_NAMES = Object.values(PRESET_ORGANIZATION_PARAMETERS);

// Preset of Organization Values by Organization Parameter Name
export const PRESET_ORGANIZATION_VALUES = {
  [PRESET_ORGANIZATION_PARAMETERS.SUPPORTED_CLOUD]: {
    options: ['AWS', 'GCP', 'AZURE'],
    autocompleteProps: {
      multiple: true,
    },
  },
  [PRESET_ORGANIZATION_PARAMETERS.CONNECTOR]: {
    options: ['LINKEDIN', 'MICROSOFT', 'META', 'HYBRID_PG'],
    autocompleteProps: {
      multiple: true,
    },
  },
  [PRESET_ORGANIZATION_PARAMETERS.IDENTITY_RESOLUTION_CLOUD]: {
    options: ['AWS', 'GCP', 'AZURE'],
    autocompleteProps: {
      multiple: false,
    },
    defaultValue: 'GCP',
  },
  [PRESET_ORGANIZATION_PARAMETERS.IDENTITY_RESOLUTION_REGION]: {
    options: ['REGION_US', 'REGION_EU', 'REGION_APAC', 'REGION_UAE'],
    autocompleteProps: {
      multiple: false,
    },
    defaultValue: 'US',
  },
  [PRESET_ORGANIZATION_PARAMETERS.IDENTITY_RESOLUTION_SUB_REGION]: {
    options: ['SUB_REGION_EAST1',
      'SUB_REGION_EAST2',
      'SUB_REGION_SOUTHEAST1',
      'SUB_REGION_ME_CENTRAL1',
      'SUB_REGION_EU_WEST4',
      'SUB_REGION_US_CENTRAL1'],
    autocompleteProps: {
      multiple: false,
    },
    defaultValue: 'SUB_REGION_EAST1',
  },
  [PRESET_ORGANIZATION_PARAMETERS.IDENTITY_RESOLUTION_SNOWFLAKE_REGION_ID]: {
    options: ['AWS_US_EAST_1'],
    autocompleteProps: {
      multiple: false,
    },
    defaultValue: 'AWS_US_EAST_1',
  },
  [PRESET_ORGANIZATION_PARAMETERS.SNOWFLAKE_RESOLUTION_CLOUD]: {
    options: ['AWS', 'GCP', 'AZURE'],
    autocompleteProps: {
      multiple: false,
    },
    defaultValue: 'AWS',
  },
  [PRESET_ORGANIZATION_PARAMETERS.SNOWFLAKE_RESOLUTION_REGION]: {
    options: ['US_WEST_2', 'US_CENTRAL1', 'US_EAST_1', 'US_EAST_2', 'EASTUS2', 'WESTEUROPE', 'EUROPE_WEST4', 'AP_SOUTHEAST_2'],
    autocompleteProps: {
      multiple: false,
    },
    defaultValue: 'US_WEST_2',
  },
};

// Preset of Organization Categories by Organization Parameter Name
export const PRESET_ORGANIZATION_CATEGORIES = {
  [PRESET_ORGANIZATION_PARAMETERS.SUPPORTED_CLOUD]: {
    options: ['TEE'],
  },
  [PRESET_ORGANIZATION_PARAMETERS.CONNECTOR]: {
    options: ['TEE'],
  },
  [PRESET_ORGANIZATION_PARAMETERS.RESOLUTION_MAX_TIMEOUT_HOURS]: {
    options: ['IDENTITY_RESOLUTION'],
  },
  [PRESET_ORGANIZATION_PARAMETERS.IDENTITY_RESOLUTION_CLOUD]: {
    options: ['IDENTITY_RESOLUTION'],
  },
  [PRESET_ORGANIZATION_PARAMETERS.IDENTITY_RESOLUTION_REGION]: {
    options: ['IDENTITY_RESOLUTION'],
  },
  [PRESET_ORGANIZATION_PARAMETERS.IDENTITY_RESOLUTION_SUB_REGION]: {
    options: ['IDENTITY_RESOLUTION'],
  },
  [PRESET_ORGANIZATION_PARAMETERS.IDENTITY_RESOLUTION_SNOWFLAKE_REGION_ID]: {
    options: ['IDENTITY_RESOLUTION'],
  },
  [PRESET_ORGANIZATION_PARAMETERS.SNOWFLAKE_RESOLUTION_CLOUD]: {
    options: ['IDENTITY_RESOLUTION'],
  },
  [PRESET_ORGANIZATION_PARAMETERS.SNOWFLAKE_RESOLUTION_REGION]: {
    options: ['IDENTITY_RESOLUTION'],
  },
};

export const isInputOrgParameter = (item) => item.type === 'add';
